import httpClient from "./httpClient";

export interface KgContext {
  userId?: string;
  orgId?: string;
}

export async function updateContactGraph(payload: {
  clientId: string;
  _id: string;
  relationshipType: string;
  isPrimary: boolean;
  orgId: string;
  userId: string;
}): Promise<void> {
  await httpClient("/kg/sync-contact", {
    method: "POST",
    body: { ...payload, contactId: payload._id },
  });
}

export async function deleteContactGraph(payload: {
  clientId: string;
  _id: string;
  relationshipType?: string;
}): Promise<void> {
  await httpClient("/kg/delete-contact", { method: "POST", body: payload });
}

export async function createClientGraph(
  client: {
    _id: string;
    name?: string;
    entityType?: string;
    orgId?: string;
    contactId?: string | null;
    address?: Record<string, unknown>;
    profile?: Record<string, unknown>;
  },
  ctx: KgContext = {}
): Promise<void> {
  const clientIdStr = client._id?.toString?.() ?? client._id;
  await httpClient("/kg/create_client_graph", {
    method: "POST",
    body: {
      clientId: clientIdStr,
      _id: clientIdStr,
      org_id: client.orgId?.toString?.() ?? client.orgId ?? ctx.orgId,
      user_id: ctx.userId?.toString?.() ?? ctx.userId,
      name: client.name,
      entityType: client.entityType,
      contactId: client.contactId?.toString?.() ?? client.contactId ?? null,
      address: client.address || {},
      profile: client.profile || {},
    },
  });
}

export async function seedOntology(): Promise<void> {
  await httpClient("/seeding/ontology", { method: "POST", body: {} });
}

export async function seedFactfindOntology(orgId: string): Promise<void> {
  await httpClient("/seeding/factfind/ontology", { method: "POST", body: { orgId } });
}

export async function deleteClientGraph(
  clientId: string,
  ctx: KgContext = {}
): Promise<void> {
  const clientIdStr = clientId?.toString?.() ?? clientId;
  await httpClient("/kg/delete-client", {
    method: "POST",
    body: {
      clientId: clientIdStr,
      _id: clientIdStr,
      org_id: ctx.orgId,
      user_id: ctx.userId,
    },
  });
}
